import { Component, ViewChild, OnInit, ViewChildren, QueryList, AfterViewInit, OnDestroy } from '@angular/core';
import { MessageDialogComponent } from '../../../../core/message-dialog/message-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpRepositoryService } from '../../../../core/http-repository.service';
import { ContactListContacts, CustomFieldJson, ContactListContact } from '../contact-list-contacts.model';
import { Location } from '@angular/common';
import { map } from 'rxjs/operators';
import { MessageType } from '../../../../core/message-dialog/message-type.enum';
import { AntiForgeryTokenService } from '../../../../auth/anti-forgery-token.service';
import { SubSink } from 'subsink';
import { UserCompanyService } from '../../../../nav-menu/user-company.service';
import { Title } from '@angular/platform-browser';

declare var $: any;
declare var Toast: any;

@Component({
  selector: 'unsubscribed-contacts',
  templateUrl: './unsubscribed-contacts.component.html',
  styleUrls: ['./unsubscribed-contacts.component.css']
})

export class UnsubscribedContactsComponent implements OnInit, AfterViewInit, OnDestroy {
  private id: number;
  private dataTable: any;
  private dtTable: any;
  private dtOptions: any;
  private navbarHeadline: any;
  private contactListContacts: ContactListContacts = new ContactListContacts(0, null, [], []);
  private selectedCompany: number;
  private selectCompanyHtmlElement: any;
  private subs = new SubSink();

  @ViewChildren('contactCustomFieldValues') contactCustomFieldValues: QueryList<any>;
  @ViewChild('msgDialog', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private route: ActivatedRoute, private repository: HttpRepositoryService,
    private location: Location, private router: Router,
    private antiForgery: AntiForgeryTokenService,
    private companyService: UserCompanyService,
    private titleService: Title) { }

  ngOnInit() {
    this.id = parseInt(this.route.snapshot.paramMap.get('id'));

    this.subs.sink = this.companyService.currentSelectedCompanyCode.subscribe(resp => {
      this.titleService.setTitle("Link.Maketer - " + resp);
    });

    this.dataTable = $('#unsubscribedContactsTable');
    this.navbarHeadline = $('#navbarHeadline');
    this.selectCompanyHtmlElement = $('#selectCompanyDropdown');
    this.loadData();
  }

  ngAfterViewInit() {
    this.contactCustomFieldValues.changes.subscribe(resp => {
      if (!this.dtTable) {
        this.createDataTable();
      }
    });
  }

  private createDataTable() {
    var that = this;

    this.dtOptions = {
      columns: [
        {
          name: 'idcontactcontactlist',
          visible: false
        },
        {
          name: 'id',
          visible: false
        },
        {
          name: 'email'
        },
        {
          name: 'phone'
        }
      ],
      orderBy: [[1, 'asc']],
      rowButtons: {
        header: 'Options',
        dropdown: {
          text: '<i class="fas fa-ellipsis-v"></i>',
          class: '',
        },
        buttons: [{
          text: '<i class="fas fa-user-check"></i> Resubscribe',
          class: 'resubscriberow',
          dataAttributes: ['idcontactcontactlist'],
          action: function (id) {
            that.resubscribe(id);
          }
        }]
      },
      buttons: [{
        text: '<i class="fas fa-arrow-left"></i>',
        class: '',
        action: function () {
          that.goBack()
        }
      },
      {
        text: '<i class="fas fa-users"></i> ',
        class: '',
        action: function () {
          that.listResubscribe();
        }
      }]
    }

    this.contactListContacts.customFields.forEach(function (item) {
      if (item.type == 'logical') {
        that.dtOptions.columns.push({
          name: item.name,
          class: 'text-center',
          filterable: false,
          width: '100px',
          renderBoolAsCheckbox: true,
          boolTrueValue: 'true',
          boolFalseValue: 'false',
          useFalseIcon: true
        });
      } else {
        that.dtOptions.columns.push({ name: item.name })
      }
    });

    this.dtTable = this.dataTable.LinkTable(this.dtOptions);
  }

  private loadData() {
    let that = this;
    this.selectCompanyHtmlElement.addClass('disabled');

    this.subs.sink = this.companyService.currentSelectedCompany.subscribe(cmpRes => {
      this.selectedCompany = cmpRes;

      if (this.selectedCompany == 0)
        this.router.navigate(['/notfound']);

      this.subs.sink = this.repository.get<ContactListContacts>('api/ContactList/Unsubscribers/' + this.id + '?companyId=' + this.selectedCompany).pipe(map(x => x.data)).subscribe(resp => {
        this.contactListContacts = resp;

        this.navbarHeadline.html(this.contactListContacts.name + ' - Usubscribed contacts');

        this.contactListContacts.contacts.forEach(function (contact) {
          contact.customFieldsJson = that.updateCustomFields(that.contactListContacts.customFields, contact.customFieldsJson);
        });

        if (this.contactListContacts.contacts.length == 0 && this.contactListContacts.customFields.length == 0) {
          if (!this.dtTable) {
            this.createDataTable();
          }
        }
      });
    });
  }

  private goBack() {
    this.location.back();
  }

  private resubscribe(idContactContactList) {
    let contact = this.contactListContacts.contacts.find(x => x.idContactContactList == idContactContactList);
    let resubscribeContact = new Resubscribe(contact.id, this.contactListContacts.idContactList);

    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Reassign contact', 'error');
      } else {
        this.msgDialog.show("Are you sure you want to resubscribe " + (contact.email ? contact.email : contact.phone) + "?", MessageType.YESNO, "Resubscribe conformation!", () => {
          this.subs.sink = this.repository.post<Resubscribe>('api/Contact/Reassign', resubscribeContact, afResp.data).subscribe(resp => {
            if (resp.hasErrors) {
              Toast.Show(resp.error, 'Reassign contact', 'error');
            } else {
              Toast.Show('Contact successfully Reassigned.', 'Reassign contact', 'success');
            }

            let rowIndex = this.dtTable.GetRowIndexes('idcontactcontactlist', idContactContactList);
            this.dtTable.DeleteRow(rowIndex[0]);
          });
        });
      }
    });
  }

  private listResubscribe() {
    let that = this;
    let checked: number[] = this.dtTable._dataTable.rows('.selected').data().toArray().map(x => x.idcontactcontactlist);
    let checkedContacts: Resubscribe[] = that.dtTable._dataTable.rows('.selected').data().toArray().map((x) => {
      return new Resubscribe(parseInt(x.id), that.id);
    });

    if (checked.length < 1) {
      that.msgDialog.show("You must select contact!", MessageType.OK, "Delete conformation");
    } else {
      this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
        if (afResp.hasErrors) {
          Toast.Show(afResp.error, 'Reassign contact', 'error');
        } else {
          this.msgDialog.show("Are you sure you want to resubscribe " + checked.length + " item(s)?", MessageType.YESNO, "Resubscribe conformation!", () => {
            this.subs.sink = this.repository.post<Resubscribe[]>('api/Contact/ListReassign', checkedContacts, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Reassign contact', 'error');
              } else {
                Toast.Show('Contact(s) successfully Reassigned.', 'Reassign contact', 'success');
              }

              checked.forEach(function (selected) {
                let contactIndex = that.contactListContacts.contacts.map(function (item) { return item.idContactContactList }).indexOf(Number(selected));
                let contact: ContactListContact = that.contactListContacts.contacts[contactIndex];
                let rowIndex = that.dtTable.GetRowIndexes('id', contact.id);
                that.dtTable.DeleteRow(rowIndex[0]);
              });
            });
          });
        }
      });
    }
  }

  private updateCustomFields(contactListCustomFields: CustomFieldJson[], contactCustomField: CustomFieldJson[]) {
    let updatedData: CustomFieldJson[] = []

    contactListCustomFields.forEach(function (clcf) {
      let contact = contactCustomField.find(x => x.idCustomField == clcf.idCustomField);

      if (!contact) {
        updatedData.push(clcf);
      }

      contactCustomField.forEach(function (ccf) {
        if (ccf.idCustomField == clcf.idCustomField)
          updatedData.push(ccf);
      });

    });

    return updatedData;
  }

  ngOnDestroy() {
    this.subs.unsubscribe();

    if (this.dtTable) {
      this.dtTable.Destroy();
      this.dtTable = null;
    }

    if (this.selectCompanyHtmlElement.hasClass('disabled')) {
      this.selectCompanyHtmlElement.removeClass('disabled');
    }
  }
}

export class Resubscribe {
  idContact: number;
  idContactList: number;

  constructor(idContact: number, idContactList: number) {
    this.idContact = idContact;
    this.idContactList = idContactList;
  }
}
